package frontend

import OrdersScreenUI
import androidx.compose.runtime.*
import net.sergeych.ugdx.GuestAPI
import components.*
import frontend.lib.Route
import frontend.lib.Routes
import frontend.lib.classList
import frontend.lib.classList
import frontend.models.User
import frontend.pages.InvoicesScreenUI
import frontend.pages.MarketScreenUI
//import frontend.pages.AccountsScreenUI
import frontend.pages.WalletScreenUI
import kotlinx.browser.window
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.InternalCoroutinesApi
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.js.RegExp


class DashboardContext() {

//    var currentScreen by mutableStateOf(DBScreen.Market)
    var isMobileMenuOpen by mutableStateOf(false)

//    fun showScreen(screen: DBScreen) { currentScreen = screen }
}

//class ImportContext(val app: App) {
//    private val defaultAccount = if (app.user?.externalAccounts?.size > 0) app.externalAccounts[0] else ""
//    var showAttachModal by mutableStateOf(false)
//    var selectedAccount by mutableStateOf(defaultAccount)
//}

//@Composable
//fun ExportScreenUI(app: App) {
//    val context = remember { ImportContext(app) }
//    var amount by mutableStateOf("")
//    var commission by mutableStateOf("")
//    var isCommissionLoading by mutableStateOf(false)
//    val scope = rememberCoroutineScope()
//
//    fun loadCommission() {
//        if (amount == "") {
//            commission = ""
//            return
//        }
//
//        isCommissionLoading = true
//
//        scope.launch {
//            delay(500L)
//            commission = (amount.toFloat() * 0.13).toString()
//            isCommissionLoading = false
//        }
//    }
//
//    @Composable
//    fun label() {
//        Text("Select account or ")
//        A("javascript:void(0);", attrs = {
//            classes("font-medium", "text-indigo-600", "hover:text-indigo-500")
//            onClick { context.showAttachModal = true }
//        }) { Text("attach new one") }
//    }
//
//    TWForm {
//        H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
//            Text("Withdraw")
//        }
//
//        TWSelect("selectedAcc", { label() }, context.selectedAccount, app.externalAccounts.toMutableList()) {
//            println("run on click $it")
//            context.selectedAccount = it
//        }
//        TTextInput("amount", amount) {
//            numeric()
//            label { Text("Amount") }
//            onInput { amount = it }
//            onChange { loadCommission() }
//        }
//
//        TTextInput("commission", commission) {
//            numeric()
//            disabled()
//            label {
//                if (isCommissionLoading) Text("Loading commission...")
//                else Text("Commission")
//            }
//            onInput { amount = it }
//        }
//
//        TWButton("Request withdraw") {
//            if (amount != "" && !isCommissionLoading) {
//                println("request order ok: $amount")
//            }
//        }
//    }
//
//    if (context.showAttachModal) AccountAttachModal(app) {
//        context.selectedAccount = it
//        context.showAttachModal = false
//    }
//}

//@Composable
//fun ImportScreenUI(app: App) {
////    val context = remember { ImportContext(app) }
//    var amount by mutableStateOf("")
//    var commission by mutableStateOf("")
//    var isCommissionLoading by mutableStateOf(false)
//    val scope = rememberCoroutineScope()
//
//    fun loadCommission() {
//        if (amount == "") {
//            commission = ""
//            return
//        }
//
//        isCommissionLoading = true
//
//        scope.launch {
//            delay(500L)
//            commission = (amount.toFloat() * 0.13).toString()
//            isCommissionLoading = false
//        }
//    }
//
//    TWForm {
//        H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
//            Text("Deposit")
//        }
//
//        TTextInput("amount", amount) {
//            numeric()
//            label { Text("Amount") }
//            onInput { amount = it }
//            onChange { loadCommission() }
//        }
//
//        TTextInput("commission", commission) {
//            numeric()
//            disabled()
//            label {
//                if (isCommissionLoading) Text("Loading commission...")
//                else Text("Commission")
//            }
//            onInput { amount = it }
//        }
//    }
//}



@Composable
fun Nav(app: App, routes: List<Route>, context: DashboardContext) {
    Div(attrs = { classList("hidden md:block") }) {
        Div(attrs = { classList("ml-10 flex items-baseline space-x-4") }) {
            routes.forEach {
                val route = it
                //  <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
                A("#${route.path}", attrs = {
                    if (app.router.current == route) {
                        classList("bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium")
                        attr("aria-current", "page")
                    } else {
                        classList("text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium")
                        onClick {
                            app.router.dispatch(route.path)
                        }
                    }
                }) { Text(route.title) }
            }
        }
    }
}


@Composable
fun NavMobile(app: App, routes: List<Route>, context: DashboardContext) {
    Div(attrs = { classList("px-2 py-3 space-y-1 sm:px-3") }) {
        routes.forEach {
            val route = it

            // <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
            A(href = "#", attrs = {
                if (app.router.current == route) {
                    classList("bg-gray-900 text-white block px-3 py-2 rounded-md text-base font-medium")
                    attr("aria-current", "page")
                } else {
                    classList("text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium")
                    onClick {
                        app.router.dispatch(route.path)
                        context.isMobileMenuOpen = false
                    }
                }
            }) { Text(route.title) }
        }
    }
}

fun c(isCondensed: Boolean, condensedCSS: String, commonCSS: String): String {
    return if (isCondensed) condensedCSS else commonCSS
}

@Composable
fun DashboardUI(app: App, user: User) {
    val scope = rememberCoroutineScope()
    val context = remember { DashboardContext() }
    var isProfileMenuOpen: Boolean by mutableStateOf(false)
    val isCondensed = listOf(Routes.Market.route, Routes.Default.route).contains(app.router.current)

    LaunchedEffect(true) {
        user.userAccount.accountsFlow().onEach {
            println("Received account change ${it.apiAccount.id} ${it.operation}")
            user.updateAccount(it.apiAccount)
        }.collect()
    }

    suspend fun signOut() {
        app.isLoading = true
        delay(100)
        GuestAPI().signOut()
        app.isLoading = false
    }

    fun co(condensedCSS: String, commonCSS: String): String {
        val isCondensed = listOf(Routes.Market.route, Routes.Default.route).contains(app.router.current)
        return c(isCondensed, condensedCSS, commonCSS)
    }

    Div(attrs = { classList("min-h-full") }) {
        Div(attrs = {
            if (isCondensed) {
                style {
                    property("z-index", "100")
                    position(Position.Absolute)
                    width(100.percent)
                }
            }
            classList("bg-gray-800 ${co("none", "pb-32")}")
        }) {
            Nav(attrs = { classList("bg-gray-800") }) {
                Div(attrs = {
                    classList("${co( "none", "max-w-7xl")} mx-auto ${co( "px-2", "sm:px-6 lg:px-8")}")
                }) {
                    Div(attrs = { classList("border-b border-gray-700") }) {
                        Div(attrs = { classList("flex items-center justify-between ${co("none", "h-16")} px-4 sm:px-0") }) {
                            Div(attrs = { classList("flex items-center") }) {
                                Div(attrs = { classList("flex-shrink-0") }) {
//                                    Img("https://tailwindui.com/img/logos/workflow-mark-indigo-500.svg", "United Assets", attrs = { classList("h-8 w-8") })
                                }

                                Nav(app, listOf(
                                    Routes.Market.route,
                                    Routes.Wallet.route,
                                    Routes.Orders.route,
                                    Routes.Invoices.route,
                                    Routes.Minting.route,
                                    Routes.Profile.route,
                                ), context)
                            }
                            Div(attrs = { classList("hidden md:block") }) {
                                Div(attrs = { classList("ml-4 flex items-center md:ml-6") }) {
                                    Div(attrs = { classList("text-base font-medium leading-none text-white mr-2") }) {
                                        Text(user.loginName)
                                    }

                                    Button(attrs = {
                                        classList("bg-gray-800 p-1 text-gray-400 rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white")
//                                        onClick { onSubmit() }
                                        type(ButtonType.Button)
                                    }) {
                                        Span(attrs = { classList("sr-only")}) { Text("View notifications") }
//                                      <!-- Heroicon name: outline/bell -->
                                        BellIcon()
                                    }

//                                  <!-- Profile dropdown -->
                                    Div(attrs = { classList("ml-3 relative") }) {
                                        Div() {
                                            Button(attrs = {
                                                classList("bg-gray-800 p-1 text-gray-400 rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white")
                                                onClick { isProfileMenuOpen = !isProfileMenuOpen }
                                                type(ButtonType.Button)
                                            }) {
                                                Span(attrs = { classList("sr-only")}) { Text("Open user menu") }
//                                              <!-- Heroicon name: outline/bell -->
                                                UserIcon()
                                            }
                                        }

                                        /*
                                        Dropdown menu, show/hide based on menu state.

                                        Entering: "transition ease-out duration-100"
                                        From: "transform opacity-0 scale-95"
                                        To: "transform opacity-100 scale-100"
                                        Leaving: "transition ease-in duration-75"
                                        From: "transform opacity-100 scale-100"
                                        To: "transform opacity-0 scale-95"
                                        */

                                        Div(attrs = {
                                            classList("origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none")
                                            attr("role", "menu")
                                            attr("aria-orientation", "vertical")
                                            attr("aria-labelledby", "user-menu-button")
                                            attr("tabindex", "-1")
                                            style {
                                                if (isProfileMenuOpen) display(DisplayStyle.Block)
                                                else display(DisplayStyle.None)
                                            }
                                        }) {
                                            // <!-- Active: "bg-gray-100", Not Active: "" -->
//                                            A(href = "#", attrs = {
//                                                classList("block px-4 py-2 text-sm text-gray-700")
//                                                attr("role", "menuitem")
//                                                attr("tabindex", "-1")
//                                                id("user-menu-item-0")
//                                            }) { Text("Settings") }

                                            A(href = "#", attrs = {
                                                classList("block px-4 py-2 text-sm text-gray-700")
                                                attr("role", "menuitem")
                                                attr("tabindex", "-1")
                                                id("user-menu-item-1")
                                                onClick { GlobalScope.launch { signOut() } }
                                            }) {
                                                Text("Sign out")
                                            }
                                        }


                                    }
                                }
                            }
                            Div(attrs = { classList("-mr-2 flex md:hidden") }) {
                                // <!-- Mobile menu button -->
                                Button(attrs = {
                                    classList("bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white")
//                                  onClick { onSubmit() }
                                    type(ButtonType.Button)
                                    attr("aria-controls", "mobile-menu")
                                    attr("aria-expanded", "false")
                                    onClick { context.isMobileMenuOpen = !context.isMobileMenuOpen }
                                }) {
                                    Span(attrs = { classList("sr-only")}) { Text("Open main menu") }
                                    XIcon(attrs = { classes("h-6", "w-6", if (context.isMobileMenuOpen) "block" else "hidden") })
                                    MenuIcon(attrs = { classes("h-6", "w-6", if (context.isMobileMenuOpen) "hidden" else "block") })
                                }

                            }
                        }
                    }
                }

                // <!-- Mobile menu, show/hide based on menu state. -->
                Div(attrs = {
                    id("mobile-menu")
                    classList("border-b border-gray-700 md:hidden")
                    style {
                        if (context.isMobileMenuOpen) display(DisplayStyle.Block)
                        else display(DisplayStyle.None)
                    }
                }) {
                    NavMobile(app, listOf(
                        Routes.Market.route,
                        Routes.Wallet.route,
                        Routes.Orders.route,
                        Routes.Invoices.route,
                        Routes.Minting.route,
                        Routes.Profile.route,
                    ), context)

                    Div(attrs = { classList("pt-4 pb-3 border-t border-gray-700") }) {
                        Div(attrs = { classList("flex items-center px-5") }) {
                            Div(attrs = { classList("flex-shrink-0 text-white") }) {
                                UserIcon()
                            }
                            Div(attrs = { classList("ml-3") }) {
                                Div(attrs = { classList("text-base font-medium leading-none text-white") }) {
                                    Text(user.loginName)
                                }
//                                Div(attrs = { classList("text-sm font-medium leading-none text-gray-400") }) {
//                                    Text("tom@example.com")
//                                }
                            }
                            Button(attrs = {
                                classList("ml-auto bg-gray-800 flex-shrink-0 p-1 text-gray-400 rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white")
//                                  onClick { onSubmit() }
                                type(ButtonType.Button)
                            }) {
                                Span(attrs = { classList("sr-only")}) { Text("View notifications") }
                                BellIcon()
                            }
                        }
                        Div(attrs = { classList("mt-3 px-2 space-y-1") }) {
//                            A(href = "#", attrs = {
//                                classList("block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700")
//                            }) { Text("Settings") }
                            A(href = "#", attrs = {
                                classList("block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700")
                                onClick { GlobalScope.launch { signOut() } }
                            }) { Text("Sign out") }
                        }
                    }
                }
            }

            if (!isCondensed) Header(attrs = { classList("py-10") }) {
                Div(attrs = { classList("max-w-7xl mx-auto px-4 sm:px-6 lg:px-8") }) {
                    H1(attrs = { classList("text-3xl font-bold text-white") }) {
                        Text(app.router.current.title)
                    }
                }
            }
        }

        Main(attrs = { classList(co("none", "-mt-32")) }) {
            Div(attrs = { classList("${co("none", "max-w-7xl")} mx-auto pb-12 ${co("px-2", "px-4 sm:px-6 lg:px-8")}") }) {
                app.router.current.show(app, user)
            }
        }
    }
}